import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { globalStateSelector } from '../../../store/selector';
import {
  globalAction,
  messageAction,
  profileAction
} from '../../../store/action';
import { connect } from 'react-redux';
import Select from 'react-select-plus';
import {
  OverflowClass,
  ProfileBody,
  BodyInner,
  BodyInnerClass,
  InnerBody,
  TeamDropDown,
  ProfileInner
} from './style';

import { Tip, Button } from 'modules/common/components';
import { Alert } from 'modules/theme';
import { NameCard } from 'modules/theme';
import styled from 'styled-components';


const SelectMenuFix = styled.div`
	.Select-menu-outer {
		height: 100px;
	}
	.Select-menu-outer > .Select-menu {
		height: 100%;
	}
`

const ProfileMain = styled.div`
  width: 360px;
  @media (max-width: 768px) {
    width: 100%;
  }
`
export class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneError: ""
    }
  }
  renderStateButton() {
    const { emitState, userState } = this.props;

    if (userState.State == 'online') {
      return (
        <React.Fragment>
          <Tip text="Pause" key={'Pause'}>
            <Button
              btnStyle="link"
              onClick={e => {
                let message = {
                  type: 'stateHandler',
                  state: 'pause',
                  subState: '',
                  stateInfo: 'Tea Break'
                };
                //  emitState({"state":"pause"})
                this.sendMessage(message);
              }}
              icon={'pause-1'}
            />
          </Tip>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <Tip text="play" key={'play'}>
            <Button
              btnStyle="link"
              onClick={e => {
                let message = {
                  type: 'stateHandler',
                  state: 'online',
                  subState: '',
                  stateInfo: ''
                };
                //  emitState({"state":"online"})
                this.sendMessage(message);
              }}
              icon={'play'}
            />
          </Tip>
        </React.Fragment>
      );
    }
  }

  sendMessage(message) {
    const { emitSocketMessage } = this.props;
    emitSocketMessage('message-processor', message);
  }
  generateParamsFromArray(tData) {
    let options = [];
    if (tData && Object.keys(tData).length > 0) {
      for (const key in tData) {
        options.push({
          value: tData[key]._id,
          label: tData[key].name
        });
      }
    } else {
      options.push({
        value: '',
        label: 'Team is not Mapped'
      });
    }
    return options;
  }
  getPhoneType() {
    return [
      { value: 'web', label: 'Browser Phone' },
      { value: 'pstn', label: 'Mobile' },
      { value: 'bridge', label: 'Mobile Bridge' },
      { value: 'mobileEndPoint', label: 'Sip Phone' }
    ];
  }
  renderSipConfig() {
    const {
      sipDomain,
      currentUser,
      regionDetail
    } = this.props;
    let userName = "",
        password = "",
        proxyServer = "",
        transport = "udp",
        port = "",
        domain = sipDomain || "";

    if( currentUser && currentUser.sip ){
      userName = currentUser.sip.userName || "";
      password = currentUser.sip.password || "";
    }
    if( regionDetail && regionDetail.sipConfig ){
      proxyServer = regionDetail.sipConfig.proxyServer || "";
      transport = regionDetail.sipConfig.transport || "";
      port = regionDetail.sipConfig.port || "";
    }

    return (
      <div className="row mt-3">
        <div className="row">
          <div className="col col-md-4 col-sm-4 mb-1">
            <h6 class="text-primary ml-6">Proxy Server</h6>
          </div>
          <div className="col col-md-8 col-sm-8"><h6 class="text-primary ml-6">{proxyServer}</h6></div>
        </div>
        <div className="row">
          <div className="col col-md-4 col-sm-4 mb-1">
            <h6 class="text-primary ml-6">Port</h6>
          </div>
          <div className="col col-md-8 col-sm-8"><h6 class="text-primary ml-6">{port}</h6></div>
        </div>
        <div className="row">
          <div className="col col-md-4 col-sm-4 mb-1">
            <h6 class="text-primary ml-6">Transport</h6>
          </div>
          <div className="col col-md-8 col-sm-8"><h6 class="text-primary ml-6">{transport}</h6></div>
        </div>
        <div className="row">
          <div className="col col-md-4 col-sm-4 mb-1">
            <h6 class="text-primary ml-6">UserName</h6>
          </div>
          <div className="col col-md-8 col-sm-8"><h6 class="text-primary ml-6">{userName}</h6></div>
        </div>
        <div className="row">
          <div className="col col-md-4 col-sm-4 mb-1">
            <h6 class="text-primary ml-6">Password</h6>
          </div>
          <div className="col col-md-8 col-sm-8"><h6 class="text-primary ml-6">{password}</h6></div>
        </div>
        <div className="row">
          <div className="col col-md-4 col-sm-4 mb-1">
            <h6 class="text-primary ml-6">Domain</h6>
          </div>
          <div className="col col-md-8 col-sm-8"><h6 class="text-primary ml-6">{domain}</h6></div>
        </div>
      </div>
    );
  }
  render() {
    const {
      teamList,
      team,
      selectTeam,
      dynamicUpdate,
      configProcessor,
      userState,
      currentUser
    } = this.props;
    let { phoneType } = this.props;

    let teamId = team && team._id ? team._id : '';
    let AgentName = currentUser && currentUser.name ? currentUser.name : "No Name";
    let profileImage = (currentUser.imagePath && currentUser.profilePic) ?
      `${currentUser.imagePath}${currentUser.profilePic}` :
      "/images/Profile.png";
    if (phoneType == "") {
      phoneType = currentUser.phoneType;
    }
    return (
      <ProfileMain>
        <ProfileBody style={{paddingTop: "30px"}}>
          {/* <ProfileInner>
            <img style={{ "borderRadius": "50%", "maxWidth": "70px" }} src={profileImage} />
          </ProfileInner> */}
			<div className="d-inline-block" >
				<NameCard.Avatar 
					user={{
						...currentUser,
						profilePic: (currentUser.imagePath &&
							currentUser.profilePic) ?
							currentUser.imagePath +
							currentUser.profilePic :
							null
						}}
						showInitials={false}
						size={60}
						/>
			</div>
			<h6>{AgentName}</h6>
          {/* <button>Change Password</button> */}
          {/* {this.renderStateButton()} */}
        </ProfileBody>
        <OverflowClass style={{height: '250px'}}>
		  <div className="row" 
			style={{    height: 'auto',
				width: '100%',
				margin: '0',
				'padding-top': '10px',
				'padding-right': '20px',
			}}>
            <div className="col-4 col-md-4 col-sm-4 mt-3 mb-4 text-center">
              <i class="fas fa-user-friends blur mr-3"></i>
              <span class="fontClass ml2">Team</span>
            </div>
            <div className="col-8 col-md-8 col-sm-8">
              <Select
                placeholder="Select Team"
                clearable={false}
                onChange={item => {
                  let value = item && item.value ? item.value : '';
                  let label = item && item.label ? item.label : '';
                  if (value) {
                    selectTeam({ _id: value, name : label });
                    dynamicUpdate({ key: 'dialPadTeamName', value: label });
                  }
                }}
                value={teamId}
                options={this.generateParamsFromArray(teamList)}
              />
            </div>
            <div className="col-4 col-md-4 col-sm-4 mt-3 mb-3 text-center">
              <i class="fas fa-phone-alt mr-3 blur"></i>
              <span class="fontClass ml2">Phone</span>
            </div>
            <SelectMenuFix className="col-8 col-md-8 col-sm-8">
              <Select
                className={'select-tag'}
                placeholder="Select Phone Type"
                clearable={false}
                onChange={item => {
                  let value = item && item.value ? item.value : '';
                  if (value) {
                    if ((value == "pstn" || value == "bridge") && !currentUser.mobile_number) {
                      // Alert.error(`Phone is Not define`);
                      // Alert.error(`${data.message}`);
                      this.setState({ "phoneError": "Mobile Phone is not configured" });
                      setTimeout(() => {
                        this.setState({ "phoneError": "" });
                      }, 5000)
                      return;
                    } else {
                      if ( value != "pstn" && userState.State == 'online') {
                        // register user
                        let message = {
                          type: 'stateHandler',
                          state: 'offline',
                          subState: '',
                          stateInfo: ''
                        };
                        //  emitState({"state":"online"})
                        this.sendMessage(message);
                      }
                      this.setState({ "phoneError": "" });
                    }
                    dynamicUpdate({ key: 'phoneType', value: value });
                    configProcessor(`updatePhoneType`, { phoneType: value });     // configProcessor ye dikkat he 
                  }
                }}
                value={phoneType}
                options={this.getPhoneType()}
              />
            </SelectMenuFix>
            {this.state.phoneError && <div className="col col-md-12 col-sm-12 text-center text-danger">{this.state.phoneError}</div>}
            { phoneType == "mobileEndPoint" && this.renderSipConfig()}
          </div>
        </OverflowClass>
      </ProfileMain>
    );
  }
}
Profile.contextTypes = {
  __: PropTypes.func
};

const stateToProps = state => ({
  teamList: globalStateSelector.getTeamList(state),
  userState: globalStateSelector.getState(state),
  team: globalStateSelector.getSelectedTeam(state),
  phoneType: globalStateSelector.getDynamic(state, { key: 'phoneType' }),
  regionDetail: globalStateSelector.getDynamic(state, { key: 'regionDetail' }),
  sipDomain: globalStateSelector.getDynamic(state, { key: 'sipDomain' }),
  currentUser: globalStateSelector.getDynamic(state, { key: 'currentUser' }),
});

const dispatchToProps = dispatch => ({
  changeTab: tName => {
    dispatch(globalAction.tabState({ data: tName }));
  },
  emitSocketMessage: (type, messageData) => {
    dispatch(messageAction.emitSocketMessage(type, messageData));
  },
  selectTeam: data => {
    dispatch(profileAction.setTeam({ team: data }));
  },
  dynamicUpdate: data => {
    dispatch(globalAction.dynamicUpdate({ data }));
  },
  configProcessor: (type, messageData) => {
    dispatch(messageAction.configProcessor(type, messageData));
  }
});

export default connect(stateToProps, dispatchToProps)(Profile);



// WEBPACK FOOTER //
// src/dialpad/components/layout/Profile.js